import React from "react";
import {
  Button,
  Container,
  Form,
  FormControl,
  Nav,
  Navbar,
} from "react-bootstrap";
import PropTypes from "prop-types";
import { ExternalLink } from "react-feather";

export default function SimpleMenuNoLanguage(props) {
  return (
    <>
      <Navbar expand="lg" title="topmenu" aria-label="topmenu">
        <Container className="mt-3">
          <Navbar.Brand className="font-weight-bold h4" href={props.homeUrl}>
            {props.title}
          </Navbar.Brand>
        </Container>
      </Navbar>
      {props.items && (
        <Navbar
          collapseOnSelect
          expand="lg"
          title="submenu"
          aria-label="submenu"
          bg={props.dark ? "primary" : "light"}
        >
          <Container
            className={
              props.dark
                ? "text-light justify-content-end justify-content-lg-between"
                : "justify-content-end justify-content-lg-between"
            }
          >
            {props.search && (
              <Form inline className=" order-lg-2 flex-nowrap">
                <FormControl
                  type="text"
                  size="sm"
                  placeholder="Søk"
                  aria-label="Søk"
                  className={props.dark && "border-secondary"}
                />
                <Button
                  size="sm"
                  variant={props.dark ? "secondary" : "primary"}
                  className="rounded-0"
                  type="submit"
                >
                  Søk
                </Button>
              </Form>
            )}

            <Navbar.Toggle
              aria-controls="responsive-navbar-nav"
              className={props.dark ? "text-light ml-4 pr-0" : "ml-4 pr-0"}
              style={{ minWidth: "130px" }}
              label="åpne/lukke meny"
              data-toggle="collapse"
              data-target="#responsive-navbar-nav"
            >
              <span className="navbar-toggler-text navbar-toggler-open font-weight-bold small mr-3">
                Meny
              </span>
              <span className="navbar-toggler-text navbar-toggler-close font-weight-bold small mr-3">
                Lukk
              </span>
              <span className="navbar-toggler-icon"></span>
            </Navbar.Toggle>
            <Navbar.Collapse
              id="responsive-navbar-nav"
              className={props.dark ? "text-light " : ""}
            >
              <Nav
                className={
                  props.search
                    ? "align-items-start w-100 mb-5 mb-lg-0"
                    : "justify-content-lg-between align-items-start w-100 mb-5 mb-lg-0"
                }
              >
                {props.items.map((item) => {
                  return (
                    <a
                      key={item.url}
                      href={item.url}
                      className={
                        props.search
                          ? "mr-lg-4 link link-bold font-weight-bold my-2 text-nowrap"
                          : "link link-bold font-weight-bold my-2 text-nowrap"
                      }
                    >
                      {item.linkText}
                      {item.externalLink && (
                        <ExternalLink
                          className="ml-1 mb-1"
                          size="19"
                          strokeWidth="2"
                        />
                      )}
                    </a>
                  );
                })}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      )}
    </>
  );
}

SimpleMenuNoLanguage.propTypes = {
  title: PropTypes.string,
  homeUrl: PropTypes.string,
  search: PropTypes.bool,
  items: PropTypes.array,
  dark: PropTypes.bool,
};

SimpleMenuNoLanguage.defaultProps = {
  homeUrl: "/",
  search: false,
  dark: false,
};
